import "./button.css";
import t from "react";
import { Link as k, Button as p } from "react-aria-components";
import { g as y } from "./elements.utils-DGLsBlHK.mjs";
import _ from "./icon.mjs";
const f = "_loading_1stdk_116", g = "_loader_1stdk_123", C = "_spin_1stdk_1", m = {
  "button-small-link": "_button-small-link_1stdk_26",
  "button-small-tertiary": "_button-small-tertiary_1stdk_26",
  "button-small-secondary": "_button-small-secondary_1stdk_26",
  "button-small-primary": "_button-small-primary_1stdk_26",
  "button-medium-link": "_button-medium-link_1stdk_26",
  "button-medium-tertiary": "_button-medium-tertiary_1stdk_26",
  "button-medium-secondary": "_button-medium-secondary_1stdk_26",
  "button-medium-primary": "_button-medium-primary_1stdk_26",
  "button-large-link": "_button-large-link_1stdk_26",
  "button-large-tertiary": "_button-large-tertiary_1stdk_26",
  "button-large-secondary": "_button-large-secondary_1stdk_26",
  "button-large-primary": "_button-large-primary_1stdk_26",
  loading: f,
  loader: g,
  spin: C
};
function L(r) {
  return r.href ? k : p;
}
function w(r) {
  return r.toLowerCase() === "large" ? "large" : "small";
}
const S = t.forwardRef(function({
  children: d,
  icon: s,
  iconAlign: e = "left",
  size: o = "medium",
  style: a,
  loading: u,
  ...n
}, i) {
  const b = L(n), c = y(
    n,
    m[`button-${o == null ? void 0 : o.toLowerCase()}-${a == null ? void 0 : a.toLowerCase()}`]
  );
  let l = null;
  return s && (l = /* @__PURE__ */ t.createElement(_, { icon: s, color: "currentcolor", size: "small" })), /* @__PURE__ */ t.createElement(b, { ...n, className: c, ref: i }, /* @__PURE__ */ t.createElement("span", { className: u ? m.loading : void 0 }, (e == null ? void 0 : e.toLowerCase()) === "left" && l, /* @__PURE__ */ t.createElement(t.Fragment, null, d), (e == null ? void 0 : e.toLowerCase()) === "right" && l), u && /* @__PURE__ */ t.createElement(
    _,
    {
      role: "img",
      "aria-label": "Loading",
      className: m.loader,
      icon: "Spinner",
      color: "currentcolor",
      size: w(o)
    }
  ));
});
export {
  S as default
};
